export default __webpack_public_path__ + "locales/pt/SMTPSettings.json?hash=e6234a5e8e04e981b121f239249800d9";